module.exports = __webpack_public_path__ + "static/media/博士考試招生簡章_110.57f2bcc3.pdf";